import { isCpf, normalizarDocumento } from './cpfcnpj-format';

const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const TAMANHO_CNPJ_SEM_DV = 12;
const REGEX_CNPJ = /^([A-Z\d]){12}(\d){2}$/;
const CNPJ_ZERADO = '00000000000000';

const charValue = (char: string) => char.charCodeAt(0) - 48;

function calcularDigitosVerificadoresCnpj(cnpjBase: string): string {
    let somatorioDV1 = 0;
    let somatorioDV2 = 0;

    for (let i = 0; i < TAMANHO_CNPJ_SEM_DV; i++) {
        const asciiDigito = charValue(cnpjBase[i]);
        somatorioDV1 += asciiDigito * PESOS_DV[i + 1];
        somatorioDV2 += asciiDigito * PESOS_DV[i];
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
    somatorioDV2 += dv1 * PESOS_DV[TAMANHO_CNPJ_SEM_DV];
    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

    return `${dv1}${dv2}`;
}

function verifica_cpf_cnpj(valor: string) {
    const normalizado = normalizarDocumento(valor);

    if (normalizado.length === 11 && /^\d{11}$/.test(normalizado)) {
        return 'CPF';
    }

    if (normalizado.length === 14 && REGEX_CNPJ.test(normalizado)) {
        return 'CNPJ';
    }

    return false;
}

function calc_digitos_posicoes(digitos: string, posicoes = 10, soma_digitos = 0) {
    for (var i = 0; i < digitos.length; i++) {
        soma_digitos = soma_digitos + (parseInt(digitos[i]) * posicoes);
        posicoes--;

        if (posicoes < 2) {
            posicoes = 9;
        }
    }

    soma_digitos = soma_digitos % 11;

    if (soma_digitos < 2) {
        soma_digitos = 0;
    } else {
        soma_digitos = 11 - soma_digitos;
    }

    var cpf = digitos + soma_digitos;

    return cpf;
}

function valida_cpf(valor: string) {
    valor = normalizarDocumento(valor);

    if (!/^\d{11}$/.test(valor)) {
        return false;
    }

    var digitos = valor.substr(0, 9);
    let novo_cpf = calc_digitos_posicoes(digitos);
    novo_cpf = calc_digitos_posicoes(novo_cpf, 11);

    if (novo_cpf === valor) {
        return true;
    }

    return false;
}

function valida_cnpj(valor: string) {
    const normalizado = normalizarDocumento(valor);

    if (!REGEX_CNPJ.test(normalizado) || normalizado === CNPJ_ZERADO) {
        return false;
    }

    const dvInformado = normalizado.substring(TAMANHO_CNPJ_SEM_DV);
    const dvCalculado = calcularDigitosVerificadoresCnpj(
        normalizado.substring(0, TAMANHO_CNPJ_SEM_DV),
    );

    return dvInformado === dvCalculado;
}

export const validarCPF = (valor: string) => valida_cpf(valor);
export const validarCNPJ = (valor: string) => valida_cnpj(valor);

export const validarCPFCNPJ = (valor: string) => {
    var valida = verifica_cpf_cnpj(valor);

    if (valida === 'CPF') {
        return valida_cpf(valor);
    }

    if (valida === 'CNPJ') {
        return valida_cnpj(valor);
    }

    return false;
};

export { isCpf };
